import { MarkedOptions, MarkedRenderer } from "ngx-markdown"
import { ProductIconSize } from "./shared/enum/productIconSize"
import { FormGroup, FormControl, FormArray } from "@angular/forms"
import { environment } from "src/environments/environment"
import { mensagem } from "./cadastro/admin/models/school/school-list"

declare var toastr: any
declare var jQuery: any
declare var $: any
declare var Clipboard: any

export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer()

  const _linkRenderer = renderer.link
  renderer.link = (href, title, text) => {
    const html = _linkRenderer.call(renderer, href, title, text)
    return html.replace(/^<a /, '<a target="_blank" rel="noopener" ')
  }

  return { renderer }
}

export class Helpers {
  static setLoading(loading) {
    const body = $("body")
    if (loading) {
      //$('.preloader-backdrop').fadeIn(200);
    } else {
      //$('.preloader-backdrop').fadeOut(200);
    }
  }

  static bodyClass(Class) {
    $("body").attr("class", Class)
  }

  static initLayout() {
    // SIDEBAR ACTIVATE METISMENU
    $(".metismenu").metisMenu()

    // SIDEBAR TOGGLE ACTION
    // $('.js-sidebar-toggler').click(function () {
    //   if ($('body').hasClass('drawer-sidebar')) {
    //     $('#sidebar').backdrop();
    //   } else {
    //     $('body').toggleClass('sidebar-mini');
    //     if (!$('body').hasClass('sidebar-mini')) {
    //       $('#sidebar-collapse').hide();
    //       setTimeout(function () {
    //         $('#sidebar-collapse').fadeIn(300);
    //       }, 200);
    //     }
    //   }
    // });

    // QUICK SIDEBAR TOGGLE ACTION
    $(".quick-sidebar-toggler").click(function () {
      $(".quick-sidebar").backdrop()
    })

    // SEARCH BAR ACTION
    $(".js-search-toggler").click(function () {
      $(".search-top-bar").backdrop().find(".search-input").focus()
    })

    // Session timeout

    let idle_timer
      ; (function () {
        $("#timeout-activate").click(function () {
          if (+$("#timeout-count").val()) {
            activate(+$("#timeout-count").val())
          }
        })

        $("#timeout-reset").click(function () {
          reset()
        })

        function reset() {
          $(document).idleTimer("destroy")
          if (idle_timer) {
            clearTimeout(idle_timer)
          }

          $("#session-dialog").modal("hide")
          $(".timeout-toggler").removeClass("active")
          $("#timeout-reset-box").hide()
          $("#timeout-activate-box").show()
        }

        function activate(count) {
          $("#session-dialog").modal("hide")
          $("#timeout-reset-box").show()
          $("#timeout-activate-box").hide()
          $(document).idleTimer(count * 60000)

          setTimeout(function () {
            $(".timeout-toggler").addClass("active")
          }, (count - 1) * 60000)

          $(document).on("idle.idleTimer", function (event, elem, obj) {
            // function you want to fire when the user goes idle
            toastr.warning(
              "Your session is about to expire. The page will redirect after 15 seconds with no activity.",
              "Session Timeout Notification",
              {
                progressBar: true,
                timeOut: 5000,
              }
            )
            idle_timer = setTimeout(timeOutHandler, 5000)
          })

          $(document).on(
            "active.idleTimer",
            function (event, elem, obj, triggerevent) {
              // function you want to fire when the user becomes active again
              clearTimeout(idle_timer)
              $(document).idleTimer("reset")
              toastr.clear()
              toastr.success("You returned to the active mode.", "You are back.")
            }
          )

          function timeOutHandler() {
            reset()
            alert(
              "Your session has expired. You can redirect this page or logout."
            )
          }
        }
      })()
  }

  static initPage() {
    // Activate bootstrap select
    if ($(".selectpicker").length > 0) {
      $(".selectpicker").selectpicker()
    }

    // Activate Tooltips
    $('[data-toggle="tooltip"]').tooltip()

    // Activate Popovers
    $('[data-toggle="popover"]').popover()

    // Activate slimscroll
    $(".scroller").each(function () {
      $(this).slimScroll({
        height: $(this).attr("data-height") || "100%",
        color: $(this).attr("data-color") || "#71808f",
        railOpacity: "0.9",
        size: "4px",
      })
    })

    $(".slimScrollBar").hide()

    // Pre Copy to clipboard

    if ($(".clipboard-copy").length > 0) {
      new Clipboard(".clipboard-copy", {
        target: function (t) {
          return t.nextElementSibling
        },
      }).on("success", function (e) {
        e.clearSelection()
        e.trigger.textContent = "Copied"
        window.setTimeout(function () {
          e.trigger.textContent = "Copy"
        }, 2000)
      })
    }

    // PANEL ACTIONS
    // ======================

    $(".ibox-collapse").click(function () {
      const ibox = $(this).closest("div.ibox")
      ibox.toggleClass("collapsed-mode").children(".ibox-body").slideToggle(200)
    })
    $(".ibox-remove").click(function () {
      $(this).closest("div.ibox").remove()
    })
    $(".fullscreen-link").click(function () {
      if ($("body").hasClass("fullscreen-mode")) {
        $("body").removeClass("fullscreen-mode")
        $(this).closest("div.ibox").removeClass("ibox-fullscreen")
        $(window).off("keydown", toggleFullscreen)
      } else {
        $("body").addClass("fullscreen-mode")
        $(this).closest("div.ibox").addClass("ibox-fullscreen")
        $(window).on("keydown", toggleFullscreen)
      }
    })
    function toggleFullscreen(e) {
      // pressing the ESC key - KEY_ESC = 27
      if (e.which === 27) {
        $("body").removeClass("fullscreen-mode")
        $(".ibox-fullscreen").removeClass("ibox-fullscreen")
        $(window).off("keydown", toggleFullscreen)
      }
    }
  }

  static formatDateToNavigatorUTC(value: any) {
    var _theDate = new Date(value)
    var hours = _theDate.getHours()
    var minutes = _theDate.getMinutes()
    var ampm = hours >= 12 ? "PM" : "AM"
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    var minutes1 = minutes < 10 ? "0" + minutes : minutes
    var strTime =
      _theDate.getMonth() +
      1 +
      "/" +
      _theDate.getDate() +
      "/" +
      _theDate.getFullYear() +
      " " +
      hours +
      ":" +
      minutes1 +
      " " +
      ampm +
      " UTC"
    return new Date(strTime)
  }

  static ToDate(value: string) {
    try {
      const date = new Date(value)
      const day = (date.getDate() < 10 ? "0" : "") + date.getDate()
      const month =
        (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1)

      return `${day}/${month}/${date.getFullYear()}`
    } catch {
      return value
    }
  }

  static s2ab(s) {
    var buf = new ArrayBuffer(s.length)
    var view = new Uint8Array(buf)
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    return buf
  }

  //data -> byte[]; type -> mimeType; fileName -> fileName with extension;
  static downLoadFile(data: any, type: any, fileName: any) {
    let byteArray = this.s2ab(atob(data))
    let blob = new Blob([byteArray], { type: type })
    let objectUrl = URL.createObjectURL(blob)
    let exportFile = document.createElement("a")
    exportFile.download = fileName
    exportFile.href = objectUrl
    exportFile.click()
  }

  //Recuperar o payload de um token estilo JWT
  static parseJwt(token): any {
    var base64Url = token.split(".")[1]
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join("")
    )

    return JSON.parse(jsonPayload)
  }

  static goToTopOfPage() {
    document.querySelector(".content-wrapper").scrollTop = 0
  }

  static goToBottomOfElement(elementSelector: string) {
    const elem = document.querySelector(elementSelector)

    elem.scroll({
      top: elem.scrollHeight - elem.clientHeight,
      behavior: "smooth",
    })

    setTimeout(() => {
      elem.scrollIntoView({ behavior: "smooth", block: "center" })
    }, 0)
  }

  static getResizedProductIcon(url, size?: ProductIconSize) {
    if (!url) return "/assets/img/default-product-icon.svg"
    if (!size) return url
    const noExtensionUrl = url.split(".").slice(0, -1).join(".") || url + ""
    return `${noExtensionUrl}_${size}x${size}.png`
  }

  // Compara o valor inicial do formulário com o valor atual, e retorna se houve alguma alteração
  static formHasChanged(form: FormGroup, formInitalState: any): boolean {
    const formHasChanged = !!Object.entries(form.controls).find(
      ([property, obj]) => {
        let newState = form.getRawValue()[property]
        let oldState = formInitalState[property]

        if (property === "cellPhoneNumber" || property === "phoneNumber") {
          newState = this.removeSpecialCharacters(newState)
        }

        if (typeof newState === "string") {
          newState = newState.trim()
        }

        if (typeof oldState === "string") {
          oldState = oldState.trim()
        }

        // (!!newState !== !!oldState) É utilizado para comparação de valores com base em falsy values (neste caso, null == a '')
        return (
          (!!newState && obj.invalid) ||
          ((newState || (obj.valid && !!newState !== !!oldState)) &&
            newState !== oldState)
        )
      }
    )
    return formHasChanged
  }

  // Aplica a função trim() nos valores do tipo string do formulário
  static applyTrimInFormValues(formValues) {
    const newFormValues = new Object()
    Object.entries(formValues).forEach(([property, value]) => {
      if (typeof value === "string") {
        const newValue = value as string
        value = newValue.trim()
      }
      newFormValues[property] = value
    })
    return newFormValues
  }

  // Retorna a mensagem de erro da requisição feita
  static getRequisitionsErrors(err, toast) {
    if (err.error || err._body) {
      const errorMsg = err.error || JSON.parse(err._body)
      if (err.status === 401 || err.status === 403) {
        window.location.href = environment.endpointSSO.url
      } else if (errorMsg.message) {
        toast.error("", `${errorMsg.message}`)
      } else {
        toast.error("", `${mensagem}`)
      }
    }
  }

  // Retorna o status e a label do status a partir de um número ou string
  static getStatusColorAndLabel(status) {
    switch (status) {
      case 1:
      case "1":
      case "Registration":
        return { label: "Inativa", colorName: "red" }
      case 2:
      case "2":
      case "Open":
        return { label: "Ativa", colorName: "green" }
      case 3:
      case "3":
      case "Closed":
        return { label: "Arquivada", colorName: "gray" }
      default:
        return { label: "Status indefinido", colorName: "" }
    }
  }

  static getHexColor(tagColor: string, index: number): string {
    return `#${tagColor.split("#").slice(1)[index]}`
  }

  static markAllFieldsAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field)
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true })
      } else if (control instanceof FormGroup) {
        this.markAllFieldsAsTouched(control)
      } else if (control instanceof FormArray) {
        control.controls.forEach((control) => {
          const controlAddress = control as FormGroup
          this.markAllFieldsAsTouched(controlAddress)
        })
      }
    })
  }

  static formIsValid(form: FormGroup): boolean {
    const formInvalid = []
    const accountFormControls = form.controls
    for (const name in accountFormControls) {
      if (accountFormControls[name].invalid) {
        formInvalid.push(name)
      }
    }
    return !(formInvalid.length > 0)
  }

  static encodeBase64Url(input: string): string {
    if (!input) return ""
    return btoa(unescape(encodeURIComponent(input)))
      .replace(/\//g, "_")
      .replace(/\+/g, "-")
  }

  static decodeBase64Url(input: string): string {
    if (!input) return ""
    return decodeURIComponent(
      escape(atob(input.replace(/_/g, "/").replace(/-/g, "+")))
    )
  }

  static addTableColumnById(tableColumns: any[], toggleColumn: any) {
    const index = tableColumns.findIndex((col) => col.id === toggleColumn.id)

    if (index === -1) {
      tableColumns.push(toggleColumn)
    }
  }

  static removeTableColumnById(tableColumns: any[], toggleColumn: any) {
    const index = tableColumns.findIndex((col) => col.id === toggleColumn.id)

    if (index !== -1) {
      tableColumns.splice(index, 1)
    }
  }

  static hasContentInArrays(arrA: string[], arrB: string[]) {
    if (arrA.length !== arrB.length) {
      return false
    }
    const arrAKeys = {}
    for (const aKey of arrA) {
      arrAKeys[aKey] = true
    }
    return arrB.every((bKey) => arrAKeys[bKey])
  }

  static parseAndValidateJwt(accessToken) {
    const parsedToken = Helpers.parseJwt(accessToken)
    const exp = new Date(parsedToken.exp * 1000)

    if (exp < new Date()) {
      return null
    }

    return parsedToken
  }

  static isAdminConexiaImpersonatingAdminSchool(accessToken, currentRole) {
    const parsedToken = Helpers.parseJwt(accessToken)

    if (!parsedToken) {
      return false
    }

    if (currentRole !== "schooladmin") {
      return false
    }

    const scopes = Array.isArray(parsedToken.scope)
      ? [...parsedToken.scope]
      : [parsedToken.scope.toString()]

    if (scopes.indexOf("conexia") === -1) {
      return false
    }

    return true
  }

  /**
   * Verifica se o usuário logado é um Admin Conexia com base nos dados retornados
   * pelo endpoint GET /api/v1/user/{userId}.
   * Um Admin Conexia tem tenantId igual ao guid vazio e perfil SchoolAdmin.
   */
  static isAdminConexiaV2(userTenantId: string, userRole: string): boolean {
    const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'
    return userTenantId === EMPTY_GUID && userRole === 'schooladmin'
  }

  static removeSpecialCharacters(value: string) {
    if (value) {
      return (value = value.replace(/[^0-9]/g, ""))
    }
  }

  static splitName(fullName: string): { firstName: string, lastName: string } {
    const nameParts = fullName.split(' ');

    const firstName = nameParts[0];

    const lastName = nameParts.slice(1).join(' ');

    return { firstName, lastName };
  }
}
